import React, { useState } from "react";
import logo from "../../asessts/Images/logo.png";
import mailIcon from "../../asessts/Images/mail_icon.svg";
import passwordIcon from "../../asessts/Images/Password_icon.svg";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import eyeSlashIcon from "../../asessts/Images/eye_close.svg";
import loginImg from "../../asessts/Images/login_img.png";
import Api from "../../services/Api";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function Login() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const handleLogin = async (e) => {
    e.preventDefault();
    localStorage.removeItem("isVerified");

    if (!email) {
      toast.error("Please enter a valid email.", {});
      return;
    }
    if (!password) {
      toast.error("Please enter password.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await Api.login(email, password);

      toast.success("Successfully sent otp");
      if (response.status === 200) {
        localStorage.setItem("careCred", JSON.stringify({ email }));
        localStorage.setItem("flowType", "login");
        navigate("/verify-otp");
      } else {
        toast.success("Something went wrong");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong");
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <section id="Dashboard-login-main">
        <div class="dashboard-input-left">
          <div class="logo">
            <img src={logo} alt="Logo" />
          </div>
          <div className="login-input-details">
            <h2>Login</h2>
            <p>Please Sign In to Continue</p>
            <form onSubmit={handleLogin}>
              <div className="input-group">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Email Address"
                />
                <span className="icon">
                  <img src={mailIcon} alt="" />
                </span>
              </div>
              <div className="input-group mb">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
                <span className="icon">
                  <img className="mobile-icon" src={passwordIcon} alt="" />
                </span>
                <span className="eye-icon" onClick={togglePasswordVisibility}>
                  <img src={showPassword ? eyeIcon : eyeSlashIcon} alt="" />
                </span>
              </div>
              <div
                className="forgot-password-link"
                style={{ textAlign: "right", marginBottom: "20px" }}
              >
                <p
                  style={{
                    color: "#C08CF6",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => navigate("/forgot-password")}
                >
                  Forgot Password ?
                </p>
              </div>

              <div className="login-btn">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? (
                    <div className="upload_loader mt-4"></div>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="login-img-right">
          <img src={loginImg} alt="" />
        </div>
      </section>
    </div>
  );
}

export default Login;
